import React, { useEffect } from "react";
import { usePagination, Pagination } from "ui";

import { useCheckoutWagesID } from "../api/get-with-checkout-wage-id";
import { CheckoutsTable } from "../../checkouts-list/components/checkouts-table";

export const CheckoutWithWageId = ({ id }: { id?: number }) => {
  const {
    page,
    pageSize,
    pageCount,
    handlePageChange,
    handlePageCountChange,
    handlePageSizeChange,
  } = usePagination();
  const { data, isLoading, error, isFetched  } = useCheckoutWagesID({
    PageNumber: page,
    PageSize: pageSize,
    SettlementDataId: id,
  });

  useEffect(() => {
    if (isFetched && data) {
      handlePageCountChange(Math.ceil(data.totalRecord / data.pageSize));
    }
  }, [data, isFetched, handlePageCountChange]);
 
  return (
    <div>
      <CheckoutsTable
        page={page}
        pageSize={pageSize}
        error={error?.message}
        checkouts={data?.data || []}
        isLoading={isLoading}
      />
      <Pagination
        page={page}
        pageSize={pageSize}
        pageCount={pageCount}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        onPageCountChange={handlePageCountChange}
      />
    </div>
  );
};
